
const services = [
  {
    icon: 'ri-paint-brush-line',
    title: 'Painting',
    description: 'Interior and exterior painting for walls, ceilings, trim, doors, and fences. Clean lines, quality finishes, and no mess left behind.',
    image: 'https://public.readdy.ai/ai/img_res/1c168668ae345ec390d6f91d0a15b6a2.jpg'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Electrical Fixes',
    description: 'Outlet and switch replacements, ceiling fan installation, light fixture swaps, and minor electrical repairs throughout your home.',
    image: 'https://readdy.ai/api/search-image?query=Handyman%20replacing%20electrical%20outlet%20and%20light%20switch%20on%20white%20wall%2C%20using%20screwdriver%20and%20voltage%20tester%2C%20safe%20residential%20electrical%20repair%2C%20clean%20modern%20home%20interior&width=600&height=400&seq=service-electrical-v2&orientation=landscape'
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Plumbing Fixes',
    description: 'Leaky faucets, running toilets, drain clogs, showerhead replacements, and minor plumbing repairs handled quickly and cleanly.',
    image: 'https://readdy.ai/api/search-image?query=Plumber%20fixing%20leaky%20faucet%20under%20kitchen%20sink%2C%20using%20wrench%20and%20plumbing%20tools%2C%20clean%20residential%20kitchen%2C%20professional%20plumbing%20repair%2C%20organized%20workspace&width=600&height=400&seq=service-plumbing-v2&orientation=landscape'
  },
  {
    icon: 'ri-sofa-line',
    title: 'Furniture Assembly',
    description: 'Expert assembly of all furniture brands including IKEA, Wayfair, Amazon, and more. Fast, precise, and hassle-free.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20handyman%20assembling%20modern%20furniture%20pieces%20in%20a%20bright%20living%20room%2C%20using%20tools%20to%20put%20together%20shelves%20and%20chairs%2C%20clean%20residential%20interior%2C%20organized%20workspace%20with%20instruction%20manuals%20and%20hardware&width=600&height=400&seq=service-furniture-v2&orientation=landscape'
  },
  {
    icon: 'ri-tv-line',
    title: 'TV Mounting',
    description: 'Safe and secure TV mounting on any wall type — drywall, brick, or concrete. Cable management included for a clean look.',
    image: 'https://readdy.ai/api/search-image?query=Technician%20mounting%20a%20large%20flat%20screen%20television%20on%20a%20clean%20white%20living%20room%20wall%2C%20using%20drill%20and%20level%20tools%2C%20professional%20TV%20installation%2C%20cable%20management%2C%20modern%20home%20interior&width=600&height=400&seq=service-tv-v2&orientation=landscape'
  },
  {
    icon: 'ri-hammer-line',
    title: 'General Home Repair',
    description: 'Drywall patching, caulking, weatherstripping, minor carpentry, and all the small fixes that keep your home in top shape.',
    image: 'https://readdy.ai/api/search-image?query=Handyman%20patching%20drywall%20and%20doing%20general%20home%20repairs%20in%20a%20residential%20room%2C%20using%20putty%20knife%20and%20sanding%20tools%2C%20clean%20interior%20setting%2C%20professional%20home%20maintenance%20work&width=600&height=400&seq=service-homerepair-v2&orientation=landscape'
  },
  {
    icon: 'ri-home-gear-line',
    title: 'Appliance Installation',
    description: 'Installation of dishwashers, microwaves, garbage disposals, washers, dryers, and other home appliances done right.',
    image: 'https://readdy.ai/api/search-image?query=Handyman%20installing%20a%20dishwasher%20and%20kitchen%20appliances%20in%20a%20modern%20residential%20kitchen%2C%20connecting%20water%20lines%20and%20electrical%2C%20professional%20appliance%20setup%2C%20clean%20organized%20kitchen%20environment&width=600&height=400&seq=service-appliance-v2&orientation=landscape'
  },
  {
    icon: 'ri-truck-line',
    title: 'Moving Help',
    description: 'Loading, unloading, and rearranging furniture and boxes. We help make your move or room refresh easier and faster.',
    image: 'https://readdy.ai/api/search-image?query=Two%20movers%20carefully%20carrying%20large%20furniture%20and%20boxes%20through%20a%20residential%20home%20doorway%2C%20professional%20moving%20help%2C%20clean%20suburban%20house%2C%20organized%20relocation%20service%2C%20bright%20daytime%20setting&width=600&height=400&seq=service-moving-v2&orientation=landscape'
  },
  {
    icon: 'ri-door-open-line',
    title: 'Doors & Windows',
    description: 'Installation and repair of interior and exterior doors, window screens, locks, handles, weatherstripping, and hardware.',
    image: 'https://readdy.ai/api/search-image?query=Handyman%20installing%20new%20door%20hardware%20and%20adjusting%20window%20frame%20in%20a%20residential%20home%2C%20using%20screwdriver%20and%20level%2C%20precise%20fitting%2C%20modern%20door%20and%20window%20installation%2C%20clean%20home%20entryway&width=600&height=400&seq=service-doors-v2&orientation=landscape'
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <strong>Services</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From small fixes to full installations — professional handyman services in Stillwater and surrounding areas, done right the first time
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-gray-50 rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
